import type { ReactElement } from 'react';

import styled, { css } from 'styled-components';

import { useProductListContext } from '../../../utilities/context/static/ProductListContext';
import { media } from '../../shared/core/styles';
import { SiteType } from '~/utilities/graphql/codegen';
import { getSiteStyles } from '~/utilities/helpers';

const S = {
  Notice: styled.p`
    ${({ theme }) => css`
      padding: ${theme.padding.sm} ${theme.padding['2xs']};
      text-align: left;
      font-size: ${theme.font.size[4]};
      color: ${theme.colors.content.secondary};

      @media ${({ theme }) => media(theme).greaterThan('sm')} {
        padding: ${theme.padding.sm} ${theme.padding.sm};
      }

      @media ${({ theme }) => media(theme).greaterThan('lg')} {
        padding: ${theme.padding.sm} ${theme.padding.md};
      }

      ${getSiteStyles(theme.siteType, {
        [SiteType.Aaf]: css`
          margin: 16px 0;
          font-size: 14px;
          font-weight: 400;
          line-height: 136%;
          letter-spacing: 0.14px;
          text-align: center;
          color: #000;
          max-width: 400px;
        `,
      })}
    `}
  `,
};

export const NoResultNotice = (): ReactElement => {
  const { systemTexts } = useProductListContext();

  return (
    <S.Notice
      data-testid="search-no-results-notice"
      dangerouslySetInnerHTML={{
        __html: systemTexts?.searchNoResult?.noResultNotice || '',
      }}
    />
  );
};
